module.exports = __webpack_public_path__ + "static/cosygiraffegrey-58267e448d183c7e663c7ea792e3d04e.jpeg";